// @flow

// Licenses
export const Licenses = Object.freeze({
  PT: 'PT',
  IT: 'IT',
  ES: 'ES',
  FR: 'FR',
  DE: 'DE',
});

// Locales
export const Locales = Object.freeze({
  EN: 'en',
  DE: 'de',
  PT: 'pt',
  IT: 'it',
  ES: 'es',
  FR: 'fr',
  BR: 'br',
});

// Country codes
export const CountryCodes = Object.freeze({
  PT: 'PT',
  IT: 'IT',
  ES: 'ES',
  FR: 'FR',
  DE: 'DE',
});

// Errors sent by the back
//
// __('You have insufficient CAPTCHA score to continue. Please try again later.')
// __('You are not permitted to create an account from this country.')
// __('You are not permitted to create this user account.')
// __('Your validation code is incorrect.')
// __('You are not authorized to access this service.')
// __('This username is unavailable.')
// __('Unable to send verification message.')
// __('Invalid phone number format.')
// __('We were unable to analyze your ID, but it has been registered. Please enter your personal details whilst waiting
// for verification.')
// __('An error has occured when checking your CAPTCHA score. Please try again later.')
// __('Unable to load profile information.')
// __('Missing application initialization parameters. Please try again.')
// __('Incorrect format in this field')
// __('Your password is not valid.')
// __('Your password:\n  -must be at least 8 characters long\n  -cannot include your username or date of birth\n  -must
// contain at least 3 of the following: (0-9), (a-z), (A-Z) and symbols (ex: @, !, #, $)')
// __('Your username is not valid, the only authorized special characters are: .&_- and space.')
// __('You have entered an invalid domiciliation code')
// __('You have entered an invalid phone number.')
// __('Your last name is not valid.')
// __('Your first name is not valid.')
// __('Your date of birth is not valid.')
// __('Your city of birth is not valid.')
// __('Your department of birth is not valid.')
// __('Your country of birth is not valid.')
// __('Your zip code of birth is not valid.')
// __('Your address is not valid.')
// __('Your zip code is not valid.')
// __('Your city is not valid.')
// __('Your state is not valid.')
// __('Your country is not valid.')
// __('Your betting stakes limit per week is not valid.')
// __('Your poker stakes limit per week is not valid.')
// __('Your deposit limit per week is not valid.')
// __('Registration not allowed from this country of residence.')
// __('Incorrect value in this field, the department does not match the city.')
// __('You must not be connected to the Winamax Poker software (desktop or mobile)')
// __('You must not be registered for any tournaments or sat at any cash game tables in order to change your table
// name')
// __('Your account is frozen.')
// __('You are already registered.')
// __('Your session has expired.')
// __('You have successfully made a request to change your password. Please check your emails.')
// __('Your identity corresponds to that of someone who has been registered as being deceased.')
// __('Invalid NIE support number format. This must start with the letter "E" or "C" and be followed by 8 numbers.')
// __('Incorrect tax code')
// __('The identity verification service is unavailable. Please try again later.')
// __('This fiscal code is already linked to an active account')
// __('Identity not verified')
// __('Too many attempts with this identity. Please try again later.')
// __('You have already transferred this file.')
// __('For a Spanish nationality, you must supply us with a DNI and not a NIE')
// __('For a foreign nationality, you must supply us with a NIE and not a DNI')
// __("You are on the Interior Ministry's banned player list!")
// __('Your identity corresponds to that of a minor.')
// __('Bank accounts from this country are not accepted on Winamax')
// __("You're way too young!")
// __("You're too young!")
// __('Your limit must be superior or equal to %1$s')
// __('Your limit must be set between %1$s and %2$s')
// __('Your limit must be inferior or equal to %1$s')
// __('No godfather found for this code')
// __('Your limit for %1$s must be inferior or equal to %2$s')
// __('Your limit for %1$s must be set between %2$s and %3$s')
// __('Your limit for %1$s must be superior or equal to %2$s')
// __('Your limit for %1$s must be inferior or equal to %2$s')
// __('Your limit for %1$s must be superior or equal to your %2$s limit')
